import * as React from 'react';
import {FormattedMessage, FormattedDate} from '@meiko/react-intl';

export default function ClientInformation({listItem}) {
	if (!listItem) {
		return null;
	}

	const client = listItem.listable.data;

	return (
		<div className="flex-1">
			<div className="text-sm">
				{client?.firstName ?? ''} {client?.lastName ?? ''}
			</div>
			<div className="text-xs text-gray-500 flex flex-wrap gap-x-2">
				{client?.email ? <span>{client.email}</span> : null}
				{client?.phone ? <span>{client.phone}</span> : null}
			</div>
			<div className="text-xs text-gray-500">
				<FormattedMessage id="Added" /> <FormattedDate value={listItem.createdAt} />
			</div>
		</div>
	);
}
